<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.edit_content_person }}
      </div>

      <personContentFrom
        v-if="Object.keys(itemPersonContent).length > 0"
        :item="itemPersonContent"
        :showDragFile="true"
        @submit="save"
        @closeModal="closeModal"
        @attachmentTemp="attachmentTemp"
        :attachmentId="attachmentId"
        :keyServies="actionResource"
        @finalSave="finalSave"
        :showAlert="false"
        mode="edit"
      />
      <uploadFile
        class="mt-1"
        v-if="pesronContentId"
        :keyServies="`person_content`"
        :parentPermissions="parentPermissions"
        :keyValue="pesronContentId"
        :file_types="file_types"
        :parentUploadFile="false"
        :outButton="outButton"
        :showAdd="false"
      />
    </b-card>
  </div>
</template>
<script>
import personContentFrom from "./../forms/personContentFrom";
import uploadFile from "@/components/base/uploadFile";
import { addAttachmentCode } from "@/components/ckeditor/submitAttachment";
export default {
  components: {
    personContentFrom,
    uploadFile,
  },
  inject: [
    "attachmentRepository",
    "attachmentTempRepository",
    "personContentRepository",
  ],
  props: {
    actionkey: {
      type: String,
      Default: "",
    },
    actionResource: {
      type: String,
      Default: "",
    },
    pesronContentId: {
      type: [String, Number],
      required: true,
      Default: "",
    },
  },

  data() {
    return {
      responseCode: [],
      file_types: ["image", "office", "media", "other"],
      attachmentId: null,
      itemPersonContent: {},
      parentPermissions: [],
      outButton: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "2",
          name: "crop",
        },
        {
          id: "1",
          name: "download",
          href: true,
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    async save(payload, allowAddAttachmentCode = true) {
      try {
        const response = await this.personContentRepository.edit(
          this.pesronContentId,
          payload
        );
        this.$notify.success(response.data.message);

        if (allowAddAttachmentCode) {
          let res = await addAttachmentCode(
            "person_content",
            this.pesronContentId,
            payload.description
          );
          if (res.fail_codes) {
            payload.description = res.description;
            await this.save(payload, false);
          }
          this.closeModal();
        } else {
          this.closeModal();
        }

        this.$emit("updateItem");
      } catch (error) {
        this.$generateError(error);
      }
    },
    async saveAttachmentTemp(file) {
      let actionResource = this.actionResource;
      let actionkey = this.actionkey;
      let formData = new FormData();
      formData.append("image", file);
      const response = await this.attachmentTempRepository.create(
        formData,
        actionResource,
        actionkey,
        {
          "Content-Type": "multipart/form-data",
        },
        true
      );
      this.responseCode.push({
        code: response.data.data.code,
        name: response.data.data.name,
        type: response.data.data.type,
      });
    },
    async finalSave(responseCode) {
      try {
        let payload = {
          data: [],
        };
        let resize_avatar = false;
        for (const item of responseCode) {
          if (item.type.match("image")) {
            if (this.keyServies == "person") {
              resize_avatar = true;
            }
          }
          payload.data.push({
            code: item.code,
            resize_avatar: resize_avatar,
          });
        }
        const result = await this.attachmentRepository.create(payload);
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.closeModal();
      }
    },
    async attachmentTemp(files) {
      Array.from(files).map((file) => {
        this.saveAttachmentTemp(file);
      });
    },
    async fetchData() {
      try {
        const response = await this.personContentRepository.find(
          this.pesronContentId
        );
        let data = response.data.data;
        this.parentPermissions = response.data.parentPermissions;
        this.itemPersonContent = data;
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
